<div>                
    <div class="info-panel dialog-title" [class.red]="request.titleStyle == 'red'">{{request.title}}</div>                                    
    <div class="info-panel label-l-grey" [class.wrap]="request.wrapText" >{{request.info}}</div>
    <div class="info-panel label-l-grey-bold">{{request.prompt}}</div>
    <div class="button-panel">
        <button *ngIf="request.okText" class="ft-btn ft-btn-inactive" [ngClass]="getStyle()" (click)="confirm(true)" style="width: 100px;">{{request.okText}}</button>
        <button *ngIf="request.cancelText" class="ft-btn ft-btn-active-not-selected" (click)="confirm(false)" style="width: 100px;">{{request.cancelText}}</button>
    </div>
</div>